import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IGeolocation } from '../../../shared/interfaces/IGeolocation';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../../shared/services/error.service';

/**
 * Service for fetching map-related location data from the backend.
 */
@Injectable({
    providedIn: 'root'
})
export class MapService {
    private readonly httpClient = inject(HttpClient);
    private readonly errorService = inject(ErrorService);
    private readonly apiUrl = environment.endpoint;

    /**
     * Fetches the geo-coordinates of all locations to be rendered on the map.
     *
     * @returns A promise that resolves to the list of geolocations, or an empty
     * array if the backend returns no data. Errors are surfaced through
     * {@link ErrorService} and re-thrown to the caller.
     */
    public getGeolocations(): Promise<IGeolocation[]> {
        const url = `${this.apiUrl}/locations/coordinates`;
        return firstValueFrom(
            this.httpClient.get<IGeolocation[]>(url).pipe(
                map(data => data ?? []),
                catchError(this.errorService.handleError<IGeolocation[]>('get geolocations'))
            )
        );
    }
}
